// Test the backend connection
export async function testBackend() {
    try {
      const response = await fetch('https://api.dmaverix.com/api/v1/test/test', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error testing backend:", error);
      throw error;
    }
  }
  
  // Function to handle user registration
  export async function registerUser(userData) {
    console.log("userData :", userData);
    try {
      const response = await fetch('https://api.dmaverix.com/api/v1/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });
  
      if (!response.ok) {
        // Capture response details for more insights
        const errorDetails = await response.json();
        console.error("Backend error details:", errorDetails);
        throw new Error(`HTTP error! Status: ${response.status} - ${errorDetails.message || "Unknown error"}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error during registration:", error);
      throw error;
    }
  }
  
  // Function to complete user registration
  export async function completeRegistration({ tempID, otp, password }) {
    console.log("Submitting complete registration data:", { tempID, otp, password });
    try {
      const response = await fetch('https://api.dmaverix.com/api/v2/auth/complete-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tempID, otp, password }),
      });
  
      if (!response.ok) {
        // Capture error details
        const errorDetails = await response.json();
        console.error("Backend error details:", errorDetails);
        throw new Error(`HTTP error! Status: ${response.status} - ${errorDetails.message || "Unknown error"}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error during registration completion:", error);
      throw error;
    }
  }
  